export const ICON_SIZES = { xxl: 64, xl: 40, l: 32, m: 24, ms: 20, s: 16, xs: 12 };
